<template>
  <div class="pie-chart-wrapper">
    <RevenueAndProfitPieChart :pieChartData="pieChartData" />

    <vue-element-loading :active="isLoading" color="#888" />
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import RevenueAndProfitPieChart from '@/components/dashboard/RevenueAndProfitPieChart'

const initialPieChartData = () => [
  { rate: 0, value: 0 },
  { rate: 100, value: 0 }
]

export default {
  name: 'RevenueAndProfitPieChartContainer',

  components: {
    RevenueAndProfitPieChart,
    VueElementLoading
  },

  props: {
    filterParams: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      isLoading: false,
      pieChartData: initialPieChartData()
    }
  },

  watch: {
    filterParams: {
      handler: 'fetchPieChartData',
      deep: true
    }
  },

  methods: {
    async fetchPieChartData () {
      try {
        this.isLoading = true
        if (this.filterParams.search) {
          const {
            data: { gross_profit: grossProfit, revenue, status }
          } = await this.$http.post(
            this.$api_url.progress_pie_chart,
            this.filterParams
          )

          if (!status) {
            // handle api error
            throw new Error('Something went wrong.')
          } else {
            this.pieChartData = [revenue, grossProfit]
          }
        }
      } catch (e) {
        this.pieChartData = initialPieChartData()
        this.$toastr.error(
          'エラーのため失敗しました。ご確認後、再試行してください。',
          'エラー'
        )
      } finally {
        this.isLoading = false
      }
    }
  }
}
</script>
